module.exports = __webpack_public_path__ + "static/media/integration.2fad3f62.png";